import PrivateLayout from "components/layout/privateLayout";
import { HealthRoutes } from "./healthRoute/index";
import { ManagementRoutes } from "./managementRoute";
import { DashboardRoute } from "./dashboardRoute";
import { TakafulProviderRoutes } from "./takafulProviderRoute";
import { ServiceProviderRoutes } from "./serviceProviderRoute";
import { IRoute } from "shared/interface/types";
import { userManagementRoutes } from "./userManagementRoutes";
import { reportRoutes } from "./reports";
import { AutoRoutes } from "./autoRoutes";
import { PartnerRoutes } from "./partnerRoutes";
import { partnerB2BUserRoutes } from "./userManagementRoutes/partnerB2BUser";
import { FamilyRoutes } from "./familyRoute";
import { PersonalAccidentRoutes } from "./personalAccidentRoute";
import { HouseholdRoutes } from "./houseHoldRoute";
import { LifeRoutes } from "./lifeRoute";
import { TravelRoutes } from "./travelRoute";

export const PrivateRoutes: IRoute[] = [
  {
    path: "/",
    element: <PrivateLayout />,
    children: [
      ...DashboardRoute,
      ...TakafulProviderRoutes,
      ...ServiceProviderRoutes,
      ...HealthRoutes,
      ...ManagementRoutes,
      ...userManagementRoutes,
      ...reportRoutes,
      ...AutoRoutes,
      ...PartnerRoutes,
      ...partnerB2BUserRoutes,
      ...FamilyRoutes,
      ...PersonalAccidentRoutes,
      ...HouseholdRoutes,
      ...LifeRoutes,
      ...TravelRoutes
    ]
  }
];
